module.exports = __webpack_public_path__ + "img/excel.821f7a92.svg";